"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EmbedWidget_1 = __importDefault(require("../EmbedWidget/EmbedWidget"));
var WidgetManager_1 = require("../../WidgetManager");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var slate_react_1 = require("slate-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var cloud_bg_light_svg_1 = __importDefault(require("@ClientAssets/Images/cloud-bg-light.svg"));
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var Types_2 = require("Tokens/Types");
var IframePlaceholder = function () { return (react_1.default.createElement("div", { className: "iframe-widget-placeholder", contentEditable: false, style: { backgroundImage: "url(\"".concat(cloud_bg_light_svg_1.default, "\")") } },
    react_1.default.createElement("div", { className: "iframe-widget-placeholder__content" },
        react_1.default.createElement(icons_1.Api, { size: icons_1.IconSize.Large }),
        react_1.default.createElement("div", { className: "iframe-widget-placeholder__instructions" }, "Embed a link to a webpage, PDF, Google Drive, or any publicly available URL")))); };
var IframeWidget = function (props) {
    var triggerWidgetEvent = function (eventData) {
        props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.Iframe, eventData));
    };
    var handleDisplayUrlChange = function (embedUrl) { return __awaiter(void 0, void 0, Promise, function () {
        var validatedUrl, updateData;
        return __generator(this, function (_a) {
            validatedUrl = embedUrl;
            updateData = {
                action: "update",
                path: slate_react_1.ReactEditor.findPath(props.widgetManager.editor, props.element),
            };
            if (embedUrl === "") {
                props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.Iframe, __assign(__assign({}, updateData), { toUpdate: { embedUrl: embedUrl } })));
                return [2];
            }
            if (embedUrl.indexOf("//") === 0) {
                validatedUrl = embedUrl.replace("//", "https://");
            }
            else if (embedUrl.indexOf("https://") !== 0 && embedUrl.indexOf("http://") !== 0) {
                validatedUrl = "https://".concat(embedUrl);
            }
            if (!(0, URL_1.isURL)(validatedUrl)) {
                throw new Error("Invalid URL provided");
            }
            props.telemetry.iframeWidgetURLUpdated(validatedUrl);
            props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.Iframe, __assign(__assign({}, updateData), { toUpdate: { embedUrl: validatedUrl } })));
            return [2];
        });
    }); };
    var instructions = props.enableTokens === Types_2.TokensEnableState.EnabledWithAllInteractions
        ? "Click or drag to add a token or paste a URL to embed"
        : "Click to add a token or paste a URL to embed";
    var variableDetails = {
        variable: props.variable,
        instructions: instructions,
        icon: icons_1.Api,
    };
    return (react_1.default.createElement("div", { className: "iframe-widget" },
        react_1.default.createElement(EmbedWidget_1.default, __assign({ embedType: "iframe", key: props.embedUrl }, props, { isSelected: props.isSelected || props.toolbarBeingUsed, displayUrl: props.embedUrl, minWidthPx: 128, minHeightPx: 128, placeholder: react_1.default.createElement(IframePlaceholder, null), placeholderText: "Paste a link to embed https://... ", triggerWidgetEvent: triggerWidgetEvent, handleDisplayUrlChange: handleDisplayUrlChange, errorMsg: "Sorry, that doesn't seem to be a valid embed URL. Double check the value and try again.", allowVariables: props.enableTokens !== Types_2.TokensEnableState.Disabled, variableDetails: variableDetails }))));
};
exports.default = IframeWidget;
